import { createSlice } from '@reduxjs/toolkit';
import axios from 'axios';

const initialState = {
  allusers: [],
  loading: false,
  error: null,
};

const userSlice = createSlice({
  name: 'allusers',
  initialState,
  reducers: {
    setUsers: (state, action) => {
      state.allusers = action.payload;
      state.loading = false;
      state.error = null;
    },
    setLoading: (state) => {
      state.loading = true;
      state.error = null;
    },
    setError: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },
  },
});

export const { setUsers, setLoading, setError } = userSlice.actions;

export const fetchUsers = () => async (dispatch) => {
  dispatch(setLoading());
  try {
    const token = localStorage.getItem('authToken'); 
    const response = await axios.get(`${process.env.REACT_APP_API_URL}/user/getalluser`, {
        headers: {
          'Authorization': `Bearer ${token}`, 
        },
      });
    dispatch(setUsers(response.data));
  } catch (error) {
    dispatch(setError(error.message));
  }
};

export default userSlice.reducer;
